<div class="flex flex-col gap-1">
    <div class="font-bold border-b border-ponder-light border-opacity-10 mb-2">
        Decks
    </div>
    <loading [isLoading]="isLoading" [success]="loadingSuccess"></loading>
    @if (!isLoading && loadingSuccess) {
        @if (isVisible) {
            @if (!decks.length) {
                <div class="text-center text-slate-500 text-sm">
                    This user has no public decks.
                </div>
            } @else {
                @for (deck of decks ; track deck.id) {
                    <deck-preview [username]="username" [isOwnDecks]="isOwnDecks" [deck]="deck"></deck-preview>
                }
                <div class="flex flex-row items-center align-middle justify-center">
                    <a href="/user/{{ username }}/decks">
                        <div class="p-1 pl-4 pr-4 mt-2 rounded-sm shadow-sm bg-slate-50 hover:text-ponder-link hover:stroke-ponder-link hover:cursor-pointer border border-transparent hover:border-ponder-link">
                            See all {{ origDeckCount }} public decks
                        </div>
                    </a>
                </div>
            }
        } @else {
            <div class="text-center text-slate-500 text-sm italic">
                Decks for this user are private.
            </div>
        }       
    }
</div>